import React, { useEffect, useState } from "react";
import classes from "./General.module.css";
import DefaultInput from "../../components/form/DefaultInput";
import { Button, Divider } from "antd";
import ButtonArrangments from "../../components/form/ButtonArrangments";
import api from "../../utils/axios";
import useLang from "../../hooks/useLang";

const General = () => {
	const [currencySymbol, setCurrencySymbol] = useState("");
	const [currencyDescription, setCurrencyDescription] = useState("");
	const { strings } = useLang("generalPage");
	const getUserById = async () => {
		try {
			const response = await api.get("User/userbyid");
			if (response.data) {
				const result = response.data;
				setCurrencySymbol(result.currencySymbol);
				setCurrencyDescription(result.currencyDescription);
			}
		} catch (error) {
			console.log(error);
		}
	};

	useEffect(() => {
		getUserById();
	}, []);

	return (
		<div className={classes.mainContainer}>
			<h1 className={classes.title}>{strings?.title}</h1>
			<div className={classes.firstContainer}>
				<div className={classes.inputContainer}>
					<DefaultInput
						label={strings?.currencySymbolLabel}
						className={classes.input}
						placeholder={strings?.currencySymbolPlaceholder}
						value={currencySymbol}
					/>
					<DefaultInput
						label={strings?.currencyDescriptionLabel}
						className={classes.input}
						placeholder={strings?.currencyDescriptionPlaceholder}
						value={currencyDescription}
					/>
					<DefaultInput
						label={strings?.conversionLabel}
						className={classes.input}
						placeholder={strings?.conversionPlaceholder}
					/>
					<DefaultInput
						label={strings?.retrievalPeriodLabel}
						className={classes.input}
						placeholder={strings?.retrievalPeriodPlaceholder}
					/>
					<DefaultInput
						label={strings?.valueChangeAllowedLabel}
						className={classes.input}
						placeholder={strings?.valueChangeAllowedPlaceholder}
					/>
				</div>
			</div>
			<Divider />
			<ButtonArrangments text={strings?.saveButtonText} />
		</div>
	);
};

export default General;
